<script lang="ts">
	interface Props {
		title?: string | null;
		clr?: string;
	}

	let { title = 'Error', clr = 'hsl(var(--clr-error-5))' }: Props = $props();
</script>

<svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" class="icon" style:--clr={clr}>
	{#if title}
		<title>{title}</title>
	{/if}
	<path
		d="M13,13H11V7H13M13,17H11V15H13M12,2A10,10 0 0,0 2,12A10,10 0 0,0 12,22A10,10 0 0,0 22,12A10,10 0 0,0 12,2Z"
	/>
</svg>

<style lang="scss">
	.icon {
		width: 2rem;
		fill: var(--clr);
	}
</style>
